import { Tooltip } from 'react-tooltip';
import { parseISO } from 'date-fns';
import { useSelector } from 'react-redux';
import { get } from 'lodash-es';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/pro-solid-svg-icons';
import { getVideoDisplaySettings } from 'common/selectors';

import { getVideoResponsibleUserSelector } from 'components/video-box/selectors';
import { Plays, UploadDate } from 'components/video-metadata/fragments';

const VideoResponsibleUserName = () => {
  const name = get(useSelector(getVideoResponsibleUserSelector), 'fullName');

  return name ? (
    <span
      data-e2e="video-responsible-user-name"
      className="ct-video-metadata__li ct-video-metadata__icon ct-video-metadata__icon--user"
    >
      <FontAwesomeIcon className="video-metadata-icon" icon={faUser} />
      {name}
    </span>
  ) : null;
};

export const VideoMetadata = ({ video }) => {
  const { uploadDate: showUploadDate, plays: showPlays } = useSelector(getVideoDisplaySettings) || {};

  const videoPlays = get(video, 'plays');
  const videoDate = get(video, 'displayDate') ? parseISO(video.displayDate) : new Date();

  return (
    <>
      <div className="ct-video-metadata">
        {showPlays && <Plays plays={videoPlays} />}
        <VideoResponsibleUserName />
        {showUploadDate && <UploadDate date={videoDate} />}
      </div>
      <Tooltip
        id="videoMetadataTooltip"
        place="top"
        effect="solid"
        type="dark"
        className={'tooltip-restyle'}
        globalEventOff="click"
      />
    </>
  );
};
